import script from "./ChangePartModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangePartModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"ChangePartModal.vue"]])

export default __exports__